module.exports = __webpack_public_path__ + "static/img/ic_exp.5c438989.svg";